import * as angular from 'angular';
import * as moment from 'moment';
import * as Cookies from 'js-cookie';

export interface CookieConsent {
    allow?: boolean;
    date?: Date;
}

export class LocalTrackingSettingsService {
    public readonly cookieName = 'tracking';

    public load(): CookieConsent | null {
        const consentObj = Cookies.getJSON(this.cookieName);
        if (consentObj) {
            return {
                allow: consentObj.allow,
                date: moment(consentObj.date).toDate()
            };
        }
        return null;
    }

    public set(allow: boolean, date = new Date()): void {
        Cookies.set(
            this.cookieName,
            {
                allow,
                date
            },
            {
                expires: 365,
                path: '/',
                domain: LocalTrackingSettingsService.getCookieDomain()
            }
        );
    }

    private static getCookieDomain(): string {
        // this regex is used to set correct domain for the cookie
        // it strips a www. and the first subdomain
        // -> www.platform.prisma-capacity.eu -> .prisma-capacity.eu
        // -> platform.prisma-capacity.eu -> .prisma-capacity.eu
        const domainMatches = /^(?:www\.)?[a-z0-9]+?(\..+)$/gi.exec(
            window.location.hostname
        );
        if (domainMatches) {
            return domainMatches[1];
        } else {
            // probably on localhost, simply do not specify a domain
            return null;
        }
    }
}

angular
    .module('app')
    .service('localTrackingSettingsService', LocalTrackingSettingsService);
